import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Representante } from './representante.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

// Utilizo el modelo de Institución por ser semejante

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class RepresentantesPartesService {

  private representantesURL: string = urlJoin(environment.apiURL, 'participantes')
  private usuariosURL: string = urlJoin(environment.apiURL, 'usuarios')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getRepresentantes(id_expediente: string): Observable<Representante[]> {
    const getrepresentantesURL = urlJoin(this.representantesURL, '/expediente/', id_expediente)
    return this.http.get<Representante[]>(getrepresentantesURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getRepresentante(id: string): Observable<any> {
    const getRepresentanteURL = urlJoin(this.representantesURL, id)
    return this.http.get<Representante>(getRepresentanteURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateRepresentante(id: string, Representante: Representante): Observable<any> {
    const updateRepresentanteURL = urlJoin(this.representantesURL, id)
    return this.http.put<Representante>(updateRepresentanteURL, Representante)
      .pipe(
        tap(() => {
          const updateRepresentanteSuccessMessage: string = $localize`:@@updateRepresentanteSuccessMessage:Representante modificado correctamente`;
          this.notificationsService.showSuccessNotification(updateRepresentanteSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  deleteRepresentante(id: string): Observable<any> {
    const deleteRepresentanteURL = urlJoin(this.representantesURL, id)
    return this.http.delete<Representante>(deleteRepresentanteURL)
      .pipe(
        tap(() => {
          const deleteRepresentanteSuccessMessage: string = $localize`:@@deleteRepresentanteSuccessMessage:Representante eliminado correctamente`;
          this.notificationsService.showSuccessNotification(deleteRepresentanteSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newRepresentante(Representante: Representante): Observable<any> {
    const newRepresentanteURL = urlJoin(this.representantesURL, "/expediente")
    return this.http.post<Representante>(newRepresentanteURL, Representante)
      .pipe(
        tap(() => {
          const newRepresentanteSuccessMessage: string = $localize`:@@newRepresentanteSuccessMessage:Nuevo representante añadido correctamente`;
          this.notificationsService.showSuccessNotification(newRepresentanteSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  checkEmail(email: string): Observable<any> {
    const checkEmailURL = urlJoin(this.usuariosURL, email, "/existeEmail")
    return this.http.get<boolean>(checkEmailURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

}
